import { OAUTH_CONFIG } from "../../OAuthAuthPage"

const socialAuthUrls = {
  shopify: "/auth/shopify",
  stripe: "/auth/stripe",
  nextcommerce: "/auth/nextcommerce"
}

export const getOAuthRedirectUrl = (socialType, data) => {
  const config = OAUTH_CONFIG[socialType]
  if (!config) return null
  if (!data) return null

  const paramKey = config.paramKey
  const paramValue = data[paramKey]
  if (!paramValue) return null

  const searchParams = new URLSearchParams({
    [paramKey]: paramValue
  })

  if (data.business_account_id) {
    searchParams.set("business_account_id", data.business_account_id)
  }

  return `${socialAuthUrls[socialType]}?${searchParams.toString()}`
}
